export default "__VITE_ASSET__D6tE4CoB__"